import React from "react";
import StarRating from "./StarRating";

const ReviewSummaryWidget = ({ reviewStats, reviews, onSeeAllReviews }) => {
  const { avgRating, totalReviews, ratingLabel, dynamicCategories } = reviewStats;

  if (totalReviews === 0) {
    return (
      <div className="review-summary-widget">
        <p className="review-summary-empty">
          No reviews yet — be the first to share your stay.
        </p>
      </div>
    );
  }

  // Prefer a recent verified review with real text; fall back to any
  // recent review with text; omit the quote entirely rather than show
  // nothing meaningful.
  const quoteReview =
    (reviews || []).find((r) => r.verified && r.review) ||
    (reviews || []).find((r) => r.review);

  const topCategory = dynamicCategories && dynamicCategories[0];

  return (
    <div className="review-summary-widget">
      <div className="review-summary-badge">
        <div className="review-summary-score">{avgRating}</div>
        <div>
          <div className="review-summary-label">{ratingLabel}</div>
          <div className="review-summary-count">{totalReviews} reviews</div>
        </div>
      </div>

      {quoteReview && (
        <div className="review-summary-quote">
          “{quoteReview.review}”
          <div className="review-summary-who">
            <span className="review-summary-avatar">
              {quoteReview.reviewer_avatar_url ? (
                <img src={quoteReview.reviewer_avatar_url} alt={quoteReview.reviewer_name} />
              ) : (
                (quoteReview.reviewer_name || "G").charAt(0).toUpperCase()
              )}
            </span>
            {quoteReview.reviewer_name || "Guest"}
            {quoteReview.verified && <span className="verified-pill">✓ Verified</span>}
          </div>
        </div>
      )}

      {topCategory && (
        <div className="review-summary-cat">
          <span>{topCategory.name}</span>
          <div className="review-summary-barwrap">
            <i style={{ width: `${(topCategory.avg / 5) * 100}%` }} />
          </div>
          <b>{topCategory.avg}</b>
        </div>
      )}

      <button type="button" className="review-summary-seeall" onClick={onSeeAllReviews}>
        See all {totalReviews} reviews →
      </button>
    </div>
  );
};

export default ReviewSummaryWidget;
